export enum Theme {
  Light = 'light',
  LightRefreshed = 'light-refreshed',
  Business = 'business-light',
}
